const upgradePersonal = {
  bannerTitle: 'HitPaw Online 究極版',
  introduct:
    'エンハンサー、リムーバ、AIトランスレータ、スクリーンレコーダーなど、スイート全体にわたる35以上のツールのプレミアム機能にアクセスし、1つの手頃な価格で利用できます。',
  Upgrade: 'アップグレード',
  Tools: 'ツールキット',
  MyProjects: '私のファイル',
  MyAccount: 'マイアカウント',
  Subscription: 'サブスクリプション',
  LogOut: 'ログアウト',
  PopularTools: '人気ツールキット',
  Enhance: '強化',
  Remove: '除去',
  Animate: 'アニメーション',
  Extract: '抽出',
  SaveThreeDays:
    'プロジェクトは3日間保存されますので、処理後にダウンロードしてください。',
  All: '全て',
  Video: '動画',
  Image: '画像',
  Audio: '音声',
  minutesAgo: '数分前',
  hoursAgo: '数時間前',
  daysAgo: '数日前',
  Modified: '修正された',
  Order: '順番',
  EarliestToLatest: '古い順',
  LatestToEarliest: '新しい順',
  NoProject: 'プロジェクトはありません。でプロジェクトから始めます。',
  OnlineTools: 'オンラインツール',
  AIVideoEnhancer: 'AI Video Enhancer',
  Enhancer4K: ' AIを利用してワンクリックで動画をオンラインで最大4Kまで強化する',
  AIPhotoEnhancer: 'AI Photo Enhancer',
  AIEnhancerImage: 'AIで最大8倍まで画像を拡大する',
  View: '閲覧',
  Download: 'ダウンロード',
  MultipleSelect: '複数選択',
  Delete: '削除',
  SubscriptionHistory: 'サブスクリプション履歴',
  NoValidSubscription: '有効なサブスクリプションがありません。',
  veContent: 'ワンクリックでビデオをオンラインで最大 4K まで AI 強化',
  peContent: 'AI がオンラインで画像をロスレスで最大 8 倍まで強化します',
  rmvContent: 'ビデオから透かしを削除する',
  rmttContent: 'TikTokビデオの透かしを瞬時に削除します',
  dynamicContent: 'オンラインで写真をアニメーション化する',
  rmbgContent: '画像から背景を削除する',
  youMayNeed: 'あなたが必要があるかもしれません',
  new: '新しい',
  loginYourAccount: 'HitPaw アカウントにログインします',
  signUpYourAccount: 'HitPaw アカウントにサインアップする',
  HitPawWatermark: 'ウォーターマーク除去オンライン',
  HitPawTiktokWatermark: 'オンライン TikTok ウォーターマーク除去ツール',
  HitPawRemoveBg: 'オンライン背景リムーバー',
  dynamicTitle: 'HitPaw Online Animate Old Photos',
};
export default upgradePersonal;
